import gql from "graphql-tag"

const SEARCH_BUNDLE_GROUPS = gql`
  query searchBundleGroups(
    $from: Int!
    $size: Int!
    $sort: [SearchSorting!]
    $query: AWSJSON
  ) {
    searchBundleGroups(
      from: $from
      size: $size
      sort: $sort
      query: $query
    ) {
      total
      hits {
        id
        name
        isActive
        validFrom
        validTo
        created
        updated
        bundles
      }
    }
  }
`

export default SEARCH_BUNDLE_GROUPS
